
const NotFound = () => {
  return <div>Error</div>;
};

export default NotFound;
